/*eslint-disable*/
import '../App.css';
import '../Section.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faYoutube, faTwitter, faReddit } from '@fortawesome/free-brands-svg-icons'
import 'animate.css';

function Footer() {

    return (
        <div className='footer' style={{ fontSize: "14px" }}>
            <div className='footer_top between'>
                <h1 style={{ fontSize: "18px", fontWeight: "bold" }}>언제나 리그오브 레전드와 함께</h1>
                <p>리그 오브 레전드 앱을 다운로드해 친구들과 대화하고 최신 게임 및 e스포츠 소식을 확인해 보세요.</p>
                <div className='center'>
                    <a href=''><img id='one' width={"120px"} src={`${process.env.PUBLIC_URL}/appStore.svg`} alt='앱스토어'></img></a>
                    <a href=''><img id='two' width={"140px"} src={`${process.env.PUBLIC_URL}/playStore.svg`} alt='플레이스토어'></img></a>
                </div>
            </div>
            <div style={{ width: "100%", backgroundColor: "#111111" }}>
                <div className='a1 center' style={{ width: "100%", backgroundColor: "#292929", padding: "24px" }}>
                    <a href=''>고객지원</a>
                    <a href=''>학부모 전용 고객센터</a>
                    <a href=''>PC방</a>
                    <a href=''>라이엇 모바일 컴패니언 앱 다운로드</a>
                </div>
                <div className='a2 center' style={{ width: "100%" }}>
                    <a href=''><FontAwesomeIcon icon={faYoutube} /></a>
                    <a href=''><FontAwesomeIcon icon={faInstagram} /></a>
                    <a href=''><FontAwesomeIcon icon={faFacebook} /></a>
                    <a href=''><FontAwesomeIcon icon={faTwitter} /></a>
                    <a href=''><FontAwesomeIcon icon={faReddit} /></a>
                </div>
                <div className='center' style={{ width: "100%", padding: "24px" }}>
                    <a id='logo_a' href=''><img onMouseOver={()=>{ $("#logo_a img").attr("src", `${process.env.PUBLIC_URL}/navLogo1_1.png`) }} width={"99px"}
                    onMouseOut={()=>{ $("#logo_a img").attr("src", `${process.env.PUBLIC_URL}/navLogo1_3.png`) }} src={`${process.env.PUBLIC_URL}/navLogo1_3.png`} alt='로고'></img></a>
                </div>
                <div className='p center' style={{ margin: "0 auto" }}>
                    <p style={{ color: "#7e7e7e" }}>
                        ™ &amp; © 2023 Riot Games, Inc.  League of Legends and all related logos, characters, names and distinctive likenesses thereof are exclusive property of Riot Games, Inc.  All Rights Reserved.
                    </p>
                </div>
                <div className='p center' style={{ margin: "0 auto" }}>
                    <p style={{ color: "#7e7e7e" }}>
                        <br />
                        라이엇게임즈코리아 유한회사 서울특별시 강남구 테헤란로 521 30층 (삼성동, 파르나스타워)
                        <br />
                        대표자 : 조혁진 | 대표전화 : 02-3454-1560 | FAX : 02-3454-1565 사업자등록번호 : 120-87-68488
                        <br />
                        통신판매업신고 : 2011-서울강남-02718
                    </p>
                </div>
                <div className='a1 center' style={{ width: "100%", padding: "26px" }}>
                    <a href=''>서비스약관</a>
                    <a href=''>개인정보 처리방침</a>
                    <a href=''>서비스 상태</a>
                    <a href=''>게임시간 선택제</a>
                    <a href=''>사회공헌</a>
                    <a href=''>사업자정보확인</a>
                    <a href=''>쿠키 설정</a>
                </div>

                <div className='footer_bottom center'>
                    <img src={`${process.env.PUBLIC_URL}/kr-rating.png`} alt='제한'></img>
                </div>
            </div>


        </div>
    )
}

export default Footer